<app-table-generator
    *ngIf="tableGenInputs"
    [tableInput]="tableGenInputs"
    (gridRef)="gridRef = $event"
    [widgetRef]="widgetRef"
></app-table-generator>
